module.exports = __webpack_public_path__ + "img/ico-reaction-03.67bd338a.svg";